import { render, staticRenderFns } from "./ProfileUserInfo.vue?vue&type=template&id=20ba8ffe&scoped=true&"
import script from "./ProfileUserInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUserInfo.vue?vue&type=style&index=0&id=20ba8ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba8ffe",
  null
  
)

export default component.exports